import React from "react";
import { Button } from "../../components/ui/button";
import { Shield, Loader2, CheckCircle2, AlertTriangle, AlertOctagon } from "lucide-react";

const VERDICT_STYLES = {
  GO: { color: "#00C805", Icon: CheckCircle2 },
  CAUTION: { color: "#FFB800", Icon: AlertTriangle },
  WARNING: { color: "#FF3B30", Icon: AlertOctagon },
};

function buttonLabel(prechecking, hasResult) {
  if (prechecking) return <><Loader2 className="h-3 w-3 animate-spin mr-2" /> Checking…</>;
  return hasResult ? "Re-Check" : "Check with AI";
}

function PreCheckResult({ precheck }) {
  const style = VERDICT_STYLES[precheck.verdict] || VERDICT_STYLES.CAUTION;
  return (
    <div className="mt-3 space-y-2" data-testid="precheck-result">
      <div className="flex items-center gap-2">
        <style.Icon className="h-4 w-4" style={{ color: style.color }} />
        <span className="text-sm font-semibold tracking-wider" style={{ color: style.color }} data-testid="precheck-verdict">{precheck.verdict}</span>
        {precheck.risk_reward != null && (
          <span className="text-[10px] text-[#71717A] num ml-auto">R:R = {precheck.risk_reward} · {precheck.history_count} similar trades</span>
        )}
      </div>
      {precheck.reason && <div className="text-xs text-[#F8F9FA] leading-relaxed" data-testid="precheck-reason">{precheck.reason}</div>}
      {precheck.suggestion && <div className="text-xs text-[#A1A1AA] italic" data-testid="precheck-suggestion">→ {precheck.suggestion}</div>}
    </div>
  );
}

export default function PreCheckPanel({ precheck, prechecking, onRun, canRun }) {
  return (
    <div className="border border-[#27272A] bg-[#08080A] rounded-sm p-3" data-testid="precheck-panel">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Shield className="h-3.5 w-3.5 text-[#007AFF]" />
          <span className="text-[10px] tracking-[0.25em] uppercase text-[#007AFF] font-semibold">Pre-Trade Checklist</span>
        </div>
        <Button type="button" data-testid="precheck-btn" size="sm" onClick={onRun} disabled={!canRun || prechecking}
          className="bg-[#007AFF] hover:bg-[#007AFF]/90 text-white rounded-sm h-7 text-[10px] tracking-wider font-semibold disabled:opacity-40">
          {buttonLabel(prechecking, !!precheck)}
        </Button>
      </div>
      {precheck?.verdict ? (
        <PreCheckResult precheck={precheck} />
      ) : (
        <div className="mt-2 text-[10px] text-[#71717A]">
          {canRun
            ? "Claude will review this trade against your history of similar setups before you commit."
            : "Fill Stock, Rate and Quantity (or Lots × Lot Size) to enable the AI check."}
        </div>
      )}
    </div>
  );
}
